import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { ButtonModule } from '../button/button.module';
import { FocusModule } from '../focus/focus.module';
import { MobileModalWindowComponent } from '../mobile-modal-window/mobile-modal-window.component';
import { MobileModalWindowModule } from '../mobile-modal-window/mobile-modal-window.module';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { InfoBoxBodyComponent } from './info-box-body.component';
import { InfoBoxForcedComponent } from './info-box-forced.component';
import { InfoBoxGridDirective } from './info-box-grid.directive';
import { InfoBoxPopoverDirective } from './info-box-popover.directive';
import { InfoBoxTertiaryComponent } from './info-box-tertiary.component';
import { InfoBoxService } from './info-box.service';

@NgModule({
  declarations: [
    InfoBoxPopoverDirective,
    InfoBoxGridDirective,
    InfoBoxForcedComponent,
    InfoBoxTertiaryComponent,
    InfoBoxBodyComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    SvgIconModule,
    NgbPopoverModule,
    ScrollbarModule,
    MobileModalWindowModule,
    FocusModule
  ],
  providers: [InfoBoxService],
  exports: [
    InfoBoxPopoverDirective,
    InfoBoxGridDirective,
    InfoBoxForcedComponent,
    InfoBoxTertiaryComponent,
    InfoBoxBodyComponent,
    MobileModalWindowComponent
  ]
})
export class InfoBoxModule {}

export * from './info-box-body.component';
export * from './info-box-forced.component';
export * from './info-box-grid.directive';
export * from './info-box-popover.directive';
export * from './info-box-tertiary.component';
export * from './info-box.service';
